import { useEffect, useState } from "react";
import api from "@/lib/api";
import Landing, { isCustomHost } from "@/pages/Landing";

const KEY = "vw_host_landing";

export default function HostRoot({ fallback }) {
  const custom = isCustomHost();
  const cached = sessionStorage.getItem(KEY);
  const [mode, setMode] = useState(!custom ? "app" : cached === "landing" ? "landing" : cached === "app" ? "app" : null);
  useEffect(() => {
    if (mode !== null) return;
    api.landingResolve("", window.location.hostname)
      .then(() => { sessionStorage.setItem(KEY, "landing"); setMode("landing"); })
      .catch(() => { sessionStorage.setItem(KEY, "app"); setMode("app"); });
  }, [mode]);
  if (mode === null) return <div className="min-h-screen bg-background" data-testid="host-root-loading" />;
  return mode === "landing" ? <Landing hostMode /> : fallback;
}
